module.exports = __webpack_public_path__ + "img/generali.9494ef41.svg";